export default "__VITE_ASSET__CmV_KCEz__"